import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { NavigateFunction } from 'react-router-dom';

import { paramConverters } from 'utils';

import { EurailQueryParams } from './query-params';

export const constructEurailBacklinkProps = (
  label: string,
  route: string,
  navigate: NavigateFunction,
  queryParams: EurailQueryParams,
) => {
  const backLinkProps: ElementsSDK.BacklinkProps = {
    label,
    onClick: () => {
      navigate({
        pathname: route,
        search: paramConverters.getURLSearchQuery(queryParams),
      });
    },
  };
  return backLinkProps;
};
